import { useState } from "react";

type RtdArr = {
    currentPrice:number
    }
const Order:React.FC<RtdArr> = ({currentPrice}) => {
    const [amount, setAmount] = useState(0);
    const [orderSelected, setOrderSelected]=useState(0);
    const orderSubmitHandler=async(e:React.FormEvent<HTMLFormElement>)=>{
        e.preventDefault();
        const formData = new FormData(e.currentTarget)
        console.log(formData)
    }
    const amountHandler =(e:any)=>{
        setAmount(e)
        console.log(e)
    }
    
    return(
        <>
            <div className="order order_container">
                <div className="order_content">
                    <div className="order_head">
                        
                        <h5>Market Order</h5>
                        <h5>Staking Order</h5>
                    </div>
                    <div className="order_body">
                        
                        <h2>body</h2>
                        <form onSubmit={orderSubmitHandler}>
                            <h5>{amount*currentPrice}</h5>
                            <input title="price" placeholder={currentPrice.toString()}/><br/>
                            <input title="amount" placeholder="amount" onChange={(e)=>amountHandler(e.target.value)}/><br/>
                            <button onClick={()=>{}}>BUY</button>
                            <button onClick={()=>{}}>SELL</button><br/>
                        </form>
                    </div>
                    <div className="order_footer">
                        
                        <h2>User Asset</h2>
                        <h2>Deposit</h2>
                        <h2>Transfer</h2>

                    </div>
                </div>
            </div>
        </>
    )
}
export default Order;